module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_7.122b5902.png";